import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { firebaseAuth } from '~/config/firebase.config';
import { ConsentChoice, onConsentChange, openConsentSettings, readConsent } from '~/services/consent/consent';
import { isLegacyAccount } from '~/services/consent/consentScope';

import styles from './Account.redesign.module.css';
import own from './PlayerLanguageCard.module.css';

function IconCookie() {
    return (
        <svg
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
        >
            <path d="M12 3a9 9 0 1 0 9 9 3 3 0 0 1-3-3 3 3 0 0 1-3-3 3 3 0 0 1-3-3Z" />
            <circle cx="9" cy="13" r="1" />
            <circle cx="14" cy="16" r="1" />
            <circle cx="8.5" cy="8.5" r="0.5" />
        </svg>
    );
}

/**
 * Carte « Cookies et confidentialité » (Mon compte) : rappelle les choix du bandeau sur CET appareil
 * (le cookie est propre à chaque navigateur) et rouvre le bandeau pour les modifier.
 */
export function ConsentCard({ index }: { index: number }) {
    const { t } = useTranslation();
    const [choice, setChoice] = useState<ConsentChoice | null>(() => readConsent());
    useEffect(() => onConsentChange(setChoice), []);

    // Compte d'avant le bandeau sans choix enregistré : accord réputé acquis (cf. ConsentLayer).
    const legacy = isLegacyAccount(firebaseAuth.currentUser?.metadata.creationTime);
    const state = (value: boolean | undefined) => {
        if (!choice) return legacy ? t('consent.default') : t('consent.none');
        return value ? t('consent.on') : t('consent.off');
    };

    return (
        <section className={styles.card} style={{ '--i': index } as React.CSSProperties}>
            <div className={styles.cardHead}>
                <div className={styles.cardIcon}>
                    <IconCookie />
                </div>
                <div>
                    <div className={styles.cardTitle}>{t('consent.accountTitle')}</div>
                </div>
            </div>
            <p className={own.rowLabel}>
                {t('consent.accountProduct')} : {state(choice?.product)}
                <br />
                {t('consent.accountAds')} : {state(choice?.ads)}
            </p>
            <button type="button" className={own.row} onClick={openConsentSettings}>
                <span className={own.rowLabel}>{t('consent.change')}</span>
            </button>
        </section>
    );
}
